'use client'
import { Typography } from "@usitsdasdesign/dds-react";
import PropTypes from "prop-types";
import React from "react";

const Heading = ({ children, type = "h1", className = "" }) => {
  const HeadingStyle = {
    h1: "dds-react-typography-h1",
    h2: "dds-react-typography-h2",
    h3: "dds-react-typography-h3",
    h4: "dds-react-typography-h4",
    h5: "dds-react-typography-h5",
    h6: "text-sm font-semibold"
  };
  const Type = type || "h1";

  const args = {
    look: type,
    className: className,
    element: type,
  };

  return (
    // <Type className={`${HeadingStyle[type]} ${className}`}>
    //   {children}
    // </Type>
    <Typography {...args}>{children}</Typography>
  );
};

export default Heading;

Heading.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.string,
};